import { render, staticRenderFns } from "./MetricsChart.vue?vue&type=template&id=03925bbd&"
import script from "./MetricsChart.vue?vue&type=script&lang=js&"
export * from "./MetricsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports